import styled from 'styled-components';

export const DropArea = styled.div`
background-color: ${props => (props.isDraggingOver ? '#00000005' : 'inherit')}`;

export const DropAreaContainer = styled.div`
background-color: ${props => (props.isDraggingOver ? '#28a74563' : 'inherit')}
border: ${props => (props.isDraggingOver ? '1px dashed #28a745' : 'inherit')}
`;